/**
 * 个股行情固底导航-分享
 */
import React, { useState } from "react"
import { ShareMomentIcon, ShareQzoneIcon, ShareWeChatIcon, ShareWeiboIcon } from "../icon"
import { quotedata } from "../quotedata"
import { getStockKind } from "../utils"
import "./index.less"

export function ShareStock(props: {quotedata:quotedata, onClose: Function }) {
  const [shareChoiceVisible, setShareChoiceVisbile] = useState(true)
  const [wxPanelVisible, setWxPanelVisbile] = useState(false)

  const clickWX = () => {
    setWxPanelVisbile(true)
    setShareChoiceVisbile(false)
  }

  const clickPanelMask = () => {
    props.onClose()
    setWxPanelVisbile(false)
    setShareChoiceVisbile(false)
  }

  const clickQQZone = ()=>{
    location.href = "http://qzs.qzone.qq.com/open/connect/widget/mobile/qzshare/index.html?url=https://emwap.eastmoney.com/quota/stock/index/" + props.quotedata.code + getStockKind(props.quotedata.market.toString(), "1") + "&appkey=801004939&title=" + props.quotedata.name + "(" + props.quotedata.code + ")股票价格_行情_走势图-东方财富&desc=" + props.quotedata.name + "(" + props.quotedata.code + ")股价走势&imageUrl=https://emfed.eastmoney.com/public/resource/img/wechatlogo.png&source=东方财富移动版&site=http://wap.eastmoney.com";
  }

  const clickWeibo = ()=>{
    location.href = "https://service.weibo.com/widget/public/login.php?source=share&backurl=https://service.weibo.com/share/mobile.php?url=https://emwap.eastmoney.com/quota/stock/index/" + props.quotedata.code + "&appkey=3050999700&title=" + props.quotedata.code + "股票价格_行情_走势图-东方财富&pic=https://emfed.eastmoney.com/public/resource/img/wechatlogo.png&source=东方财富移动版&sourceUrl=http://wap.eastmoney.com&frefer=";
  }

  return (
    <>
      <div className="share-mask share-panel-mask" onClick={clickPanelMask}></div>
      <div className="share-panel">
        {shareChoiceVisible && (
          <div className="con slide-up">
            <ul>
              <li onClick={clickWX}>
                <div>
                  <span className="wrap-wechat">
                    <ShareWeChatIcon />
                  </span>
                </div>
                <p>微信</p>
              </li>
              <li onClick={clickWX}>
                <div>
                  <span className="wrap-moment">
                    <ShareMomentIcon />
                  </span>
                </div>
                <p>朋友圈</p>
              </li>
              <li onClick={clickQQZone}>
                <div>
                  <span className="wrap-qzone">
                    <ShareQzoneIcon />
                  </span>
                </div>
                <p>QQ空间</p>
              </li>
              <li onClick={clickWeibo}>
                <div>
                  <span className="wrap-weibo">
                    <ShareWeiboIcon />
                  </span>
                </div>
                <p>微博</p>
              </li>
            </ul>
            <a
              href="#"
              className="btn-cancel"
              onClick={(e) => {
                e.preventDefault()
                props.onClose()
              }}
            >
              取消
            </a>
          </div>
        )}
        {wxPanelVisible && (
          <div
            className="wx-share-panel"
            onClick={() => {
              setWxPanelVisbile(false)
              props.onClose()
            }}
          />
        )}
      </div>
    </>
  )
}
